import React from 'react';
import PropTypes from 'prop-types';
import { MessageTextWrapper } from './message-text.styled';
import { MessageWaitWrapper } from './message-wait.styled';
function MessageWait(props) {
    return (
        <MessageTextWrapper >
            <MessageWaitWrapper>

            <div className={`message-body message-text  message-body-${props.message.party}`}>
                <div class="message-wait" id="message-wait">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            </MessageWaitWrapper>
        </MessageTextWrapper>
    )
}

MessageWait.propTypes = {
    message: PropTypes.object,
};

MessageWait.defaultProps = {
    message: null,
};

export default MessageWait;
